export default __webpack_public_path__ + "d27f29bed5c9261f044e22da9a955337.png";